export default __webpack_public_path__ + "static/media/http-auth-icon.aab1579c.svg";